document.addEventListener('change', function (e) {

  const toggle = e.target.closest('#check');

  if (!toggle) return;

  const variantId = 49981549674689;
  let formData = {
    'items': [{
        'id': variantId,
        'quantity': 1,
    }]
}
    if (toggle.checked) {
        console.log("checked")
      // ADD TO CART
      window.fetch('/cart/add.js', {
        method: 'POST',
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(formData),
    })
    .then(r => r.json())
    .then(() => { 
        Alpine.store('xMiniCart').reLoad();
    })
      .catch(err => {
        console.error('Add error:', err);
      });

    } else {
      // REMOVE FROM CART
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const item = cart.items.find(item => item.variant_id == variantId);
          if (!item) return;

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        })
        .then(() => {
          Alpine.store('xMiniCart').reLoad();
        })
        .catch(err => {
          console.error('Remove error:', err);
        });
    }

  });